import '../variables.css';
import './variables.css';
export { default } from './components/Component';

import { store } from './components/Component';
import { setLocation } from './store/segments/actions';

export const setIata = (iata: string, name: string, type: 'departure' | 'arrival') => {
	const MAX_TRIES = 20;
	let tryCount = 0;

	const interval = setInterval(() => {
		if (!store) {
			console.log('no store');
			tryCount += 1;

			return;
		}

		if (tryCount === MAX_TRIES) {
			clearInterval(interval);
		}

		clearInterval(interval);
		console.log(store);

		store.dispatch(
			setLocation(
				{
					iata: iata,
					name: name,
					stopPointsCount: null,
					match: {
						type: 'Default',
						iata: null,
						distance: null,
						name: null,
						__typename: 'LocationMatch'
					},
					__typename: 'LocationInLocationGroup'
				},
				type
			)
		);
	}, 100);
};
